export default __webpack_public_path__ + "static/media/order_1.f2f44b5c.svg";